import {computed, inject, Injectable} from '@angular/core';
import {MenuItem} from 'primeng/api';
import {RoleCheckService} from '../../shared/services/role-check.service';
import {APP_ROUTES} from '../../app.routes';

@Injectable({
  providedIn: 'root',
})
export class HeaderMenuService {
  private readonly roleCheckService = inject(RoleCheckService);

  public readonly hasProviderRole = computed(() => {
    return (
      this.roleCheckService.hasProviderAdminRole() || this.roleCheckService.hasProviderUserRole()
    );
  });

  getFilteredMenuItems(allItems: MenuItem[], isAuthenticated: boolean): MenuItem[] {
    if (!allItems.length) {
      return [];
    }

    if (!isAuthenticated) {
      return this.getUnauthenticatedMenuItems(allItems);
    }

    return this.getAuthenticatedMenuItems(allItems);
  }

  private getUnauthenticatedMenuItems(allItems: MenuItem[]): MenuItem[] {
    return allItems.filter((item) => !item['loggedIn']);
  }

  private getAuthenticatedMenuItems(allItems: MenuItem[]): MenuItem[] {
    const loggedInItems = allItems.filter((item) => item['loggedIn']);

    if (this.roleCheckService.hasSelecthorAdminRole()) {
      return this.getSelecthorAdminMenuItems(loggedInItems);
    }

    if (this.hasProviderRole()) {
      return this.getProviderMenuItems(loggedInItems);
    }

    if (this.roleCheckService.hasCustomerAdminRole()) {
      return this.getCustomerAdminMenuItems(loggedInItems);
    }

    return this.getCustomerUserMenuItems(loggedInItems);
  }

  private getSelecthorAdminMenuItems(loggedInItems: MenuItem[]): MenuItem[] {
    return loggedInItems.filter((item) => item.routerLink?.startsWith('/selecthor-admin'));
  }

  private getProviderMenuItems(loggedInItems: MenuItem[]): MenuItem[] {
    const adminRoleAccess = this.roleCheckService.hasProviderAdminRole();

    return loggedInItems.filter((item) => {
      if (
        (item.routerLink?.startsWith('/provider/users') ||
          item.routerLink?.startsWith('/provider/data') ||
          item.routerLink?.startsWith('/provider/invoices')) &&
        !adminRoleAccess
      ) {
        return false;
      }
      return item.routerLink?.startsWith('/provider');
    });
  }

  private getCustomerAdminMenuItems(loggedInItems: MenuItem[]): MenuItem[] {
    return loggedInItems.filter(
      (item) =>
        !item.routerLink?.startsWith('/provider') &&
        !item.routerLink?.startsWith('/selecthor-admin'),
    );
  }

  private getCustomerUserMenuItems(loggedInItems: MenuItem[]): MenuItem[] {
    return loggedInItems.filter((item) => item.routerLink?.startsWith(APP_ROUTES.PROJECT));
  }
}
